/**
 * Kassie App - Main Entry Point
 * Initializes the application, service worker, and routing
 */

// Legacy/unsupported-device fallback (Requirement 7): tell index.html's
// head-level watchdog this module and its whole static import graph
// actually loaded and evaluated, so it never redirects to /legacy.html.
// Written as the first statement for readability, but ES module import
// hoisting means the static imports below still run first regardless of
// source order — which is actually the stronger signal here: this line only
// executes at all if every import below resolved and evaluated without
// throwing. If any of them fails to load or has a parse error, this line
// never runs, the flag never gets set, and the watchdog fires. See
// index.html for the watchdog and legacy.html for the fallback page itself,
// which now lives entirely outside this app's own document and is never
// present in it to flash.
window.__kassieBootOk = true;

import './styles/main.css';
import { initializeApp } from './app';
import { registerServiceWorker } from './utils/serviceWorker';
import { connectivityIndicator } from './components/ConnectivityIndicator';
import { t } from './i18n/config';

// Initialize the application
document.addEventListener('DOMContentLoaded', async () => {
  try {
    // Register service worker for offline capability
    await registerServiceWorker();

    // Initialize connectivity indicator
    connectivityIndicator.init();

    // Initialize the main application
    await initializeApp();

    console.log('✅ Kassie App initialized successfully');
    console.log('📱 PWA features enabled');
    console.log('💾 Offline mode ready');

  } catch (error) {
    console.error('❌ Failed to initialize Kassie App:', error);
    // Show error UI
    document.getElementById('app').innerHTML = `
      <div class="error-screen">
        <h1>${t('app.errorScreen.title')}</h1>
        <p>${t('app.errorScreen.description')}</p>
        <button onclick="location.reload()">${t('app.errorScreen.reload')}</button>
      </div>
    `;
  }
});
